import React from 'react';

export function Tag({ children, variant = 'default', dot = false }) {
  return <span className={`tag tag-${variant} ${dot ? 'tag-dot' : ''}`}>{children}</span>;
}